import React, {Component} from 'react';
import ReportSoggettiRowView from './ReportSoggettiRowView'
import ShowTipoSoggettoCompact from '../rubrica/ShowTipoSoggettoCompact'
import { Table } from 'semantic-ui-react'
import {client} from '../../Client';
import Moment from 'moment';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'


class ReportSoggettiView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            column: null,
            direction: null,
        };
    }

    renderCompact(items) {

        // Titolo, Cognome, Nome, 3
// città, 2
// cell, 1
// tel1, 1
// email, 2
// Org, 3
// Dip, 3
// status (C/F/P/T = Cliente/Fornitore/...) 1

        let i = 0;
        return <div className="ep-outer-table">
            <div className="ep-inner-scrollable-table">

                <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell sorted={this.state.column === 'titolo' ? this.state.direction:null} >
                        Titolo
                    </Table.HeaderCell>
                    <Table.HeaderCell sorted={this.state.column === 'idUtente.nome' ? this.state.direction : null} >
                        Nome
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'citta' ? this.state.direction:null} >
                        Città
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'cellulare' ? this.state.direction:null} >
                        Cellulare
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'telefono1' ? this.state.direction:null} >
                        Telefono 1
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'email' ? this.state.direction:null} >
                        Email
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'organizzazione' ? this.state.direction:null} >
                        Organizzazione
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'dipartimento' ? this.state.direction:null} >
                        Dipartimento
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'status' ? this.state.direction:null} >
                        Status
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    items.map((item) => {
                        return <Table.Row key={i++}>
                            <Table.Cell>{item.tit}</Table.Cell>
                            <Table.Cell>{item.nomeCognome}</Table.Cell>
                            <Table.Cell>{item.citta}</Table.Cell>
                            <Table.Cell>{item.cellulare}</Table.Cell>
                            <Table.Cell>{item.telefono1}</Table.Cell>
                            <Table.Cell>{item.email}</Table.Cell>
                            <Table.Cell>{item.idDipartimento.idOrganizzazione.nomeCompleto}</Table.Cell>
                            <Table.Cell>{item.idDipartimento.nomeCompleto}</Table.Cell>
                            <Table.Cell><ShowTipoSoggettoCompact soggetto={item}/></Table.Cell>
                        </Table.Row>
                    })}
            </Table.Body>
        </Table>
            </div>
        </div>
    }

    renderCompleto(items) {

        let i = 0;
        return <div className="ep-outer-table">
            <div className="ep-inner-scrollable-table">

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell collapsing={true} sorted={this.state.column === 'id' ? this.state.direction:null} >
                                ID
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={this.state.column === 'titolo' ? this.state.direction:null} >
                                Titolo
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={this.state.column === 'idUtente.nome' ? this.state.direction : null} >
                                Nome
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' sorted={this.state.column === 'status' ? this.state.direction:null} >
                                Status
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={this.state.column === 'organizzazione' ? this.state.direction : null} >
                                Organizzazione - Dipartimento
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} sorted={this.state.column === 'cf' ? this.state.direction : null} >
                                CF
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} sorted={this.state.column === 'indirizzo' ? this.state.direction : null} >
                                Indirizzo
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true}  sorted={this.state.column === 'cap' ? this.state.direction:null} >
                                CAP
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} sorted={this.state.column === 'citta' ? this.state.direction:null} >
                                Città
                            </Table.HeaderCell>
                            <Table.HeaderCell  sorted={this.state.column === 'provincia' ? this.state.direction:null} >
                                Provincia
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true}  sorted={this.state.column === 'stato' ? this.state.direction:null} >
                                Stato
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} sorted={this.state.column === 'email' ? this.state.direction:null} >
                                e-mail
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} sorted={this.state.column === 'pec' ? this.state.direction:null} >
                                PEC
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true}  sorted={this.state.column === 'sito' ? this.state.direction:null} >
                                Sito
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'cellulare' ? this.state.direction:null} >
                                Cellulare
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'telefono1' ? this.state.direction:null} >
                                Telefono 1
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'telefono2' ? this.state.direction:null} >
                                Telefono 2
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'fax' ? this.state.direction:null} >
                                Fax
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'creatoil' ? this.state.direction:null} >
                                Creato il, da
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'modificatoil' ? this.state.direction:null} >
                                Modificato il, da
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'note' ? this.state.direction:null} >
                                Note
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            items.map((item) => {
                                return <Table.Row key={i++}>
                                    <Table.Cell>{item.idSoggetto}</Table.Cell>
                                    <Table.Cell>{item.tit}</Table.Cell>
                                    <Table.Cell>{item.nomeCognome}</Table.Cell>
                                    <Table.Cell><ShowTipoSoggettoCompact soggetto={item}/></Table.Cell>
                                    <Table.Cell>
                                        {item.idDipartimento.idOrganizzazione.nomeCompleto}
                                        {item.idDipartimento.nomeCompleto}
                                    </Table.Cell>
                                    <Table.Cell>{item.cf}</Table.Cell>
                                    <Table.Cell>{item.indirizzo}</Table.Cell>
                                    <Table.Cell>{item.cap}</Table.Cell>
                                    <Table.Cell>{item.citta}</Table.Cell>
                                    <Table.Cell>{item.provincia}</Table.Cell>
                                    <Table.Cell>{item.stato}</Table.Cell>
                                    <Table.Cell>{item.email}</Table.Cell>
                                    <Table.Cell>{item.pec}</Table.Cell>
                                    <Table.Cell>{item.web}</Table.Cell>
                                    <Table.Cell>{item.cellulare}</Table.Cell>
                                    <Table.Cell>{item.tel1}</Table.Cell>
                                    <Table.Cell>{item.tel2}</Table.Cell>
                                    <Table.Cell>{item.fax}</Table.Cell>
                                    <Table.Cell collapsing={true} textAlign="left">
                                        {item.creatoIl ?  <span><LocalDate data={item.creatoIl} /> <LocalTime data={item.creatoIl} /></span> : "?"}
                                        &nbsp;{item.creatoDa ? item.creatoDa.username : '?'}</Table.Cell>
                                    <Table.Cell collapsing={true} textAlign="left">
                                        {item.modificatoIl ?  <LocalDate data={item.modificatoIl } /> : '?'}
                                        &nbsp;
                                        {item.modificatoIl ?  <LocalTime data={item.modificatoIl } /> : null}
                                        &nbsp;{item.modificatoDa ? item.modificatoDa.username : '?'}</Table.Cell>
                                    <Table.Cell textAlign="left">{item.note}</Table.Cell>
                                </Table.Row>
                            })}
                    </Table.Body>
                </Table>
            </div>
        </div>
    }

    renderStandard(items) {
        let tableData = null
        let tableRows = [];
        let i = 0;
        items.forEach((c) => {

            let row = (
                <div className="item" key={i++}>
                    <ReportSoggettiRowView item={c}/>
                </div>
            )
            tableRows.push(row);
        });

        tableData = (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">

                <div className="ui divided items detaildataitems">
                {tableRows}
            </div>
                </div>
            </div>
        )
        return tableData;
    }

    render() {
        let items = this.props.items;
        if (items === undefined || items.length === 0){
            return null;
        }
        let tabledata = null;
        if (this.props.compact){
            tabledata = this.renderCompact(items);
        }
        else {
            tabledata = this.renderCompleto(items);
        }

        return <div>
            {tabledata}
            <div className="ui two columns grid">
                <div className="column">Stampa eseguita il <LocalDate data={Moment().format("YYYY-MM-DD")}/> alle ore <LocalTime data={Moment().format(Moment().ISO_8601)}/> da {client.getCurrentUser().nome}</div>
            </div>
        </div>
    }
}

export default ReportSoggettiView;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportSoggettiView.js
 **/